/**
 * Created by hj on 2017/10/31.
 */
import {config, request} from 'Utils';

/**
 * 获取 新的促销编码
 * @param param
 * @returns {*}
 */
export function getPromotionCode () {
  return request(`${config.server}/api/v1/dms/promotion/code`, {
    method: 'get'
  });
}

/**
 * 促销 新建
 * @param param
 * @returns {*}
 */
export function savePromotion (params) {
  return request(`${config.server}/api/v1/dms/promotion/insert`, {
    method: 'post',
    body: params
  });
}

/**
 * 促销 列表
 * @param params
 * @returns {*}
 */
export function getPromotionList (params) {
  return request(`${config.server}/api/v1/dms/promotion/list`, {
    method: 'post',
    body: params
  });
}

/**
 * 促销 详情
 * @param params
 * @returns {*}
 */
export function getPromotionDetail (id) {
  return request(`${config.server}/api/v1/dms/promotion/detail?id=${id}`, {
    method: 'get'
  });
}

/**
 * 促销 是否可编辑
 * @param params
 * @returns {*}
 */
export function getPromotionIsEdit (id) {
  return request(`${config.server}/api/v1/dms/promotion/modifiable?id=${id}`, {
    method: 'get'
  });
}

/**
 * 促销 查询已购产品列表
 * @param params
 * @returns {*}
 */
export function getPromotionLineList (params) {
  return request(`${config.server}/api/v1/dms/promotion/soldRecord`, {
    method: 'post',
    body: params
  });
}


// WEBPACK FOOTER //
// ./src/service/promotion/index.js